import { Card as MuiCard, CardProps as MuiCardProps, styled } from "@mui/material";

import { colors } from "@/Components/v2/utils/brand-colors";

const StyledCard = styled(MuiCard)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: "2rem",
  width: "100%",
  border: `1px solid ${colors.dropdownBorder}`,
  borderRadius: "8px",
  boxShadow: "none",
  [theme.breakpoints.down("xl")]: {
    padding: "1rem",
  },
}));

interface CardProps extends MuiCardProps {
  children: React.ReactNode;
}

export const LegendCard: React.FC<CardProps> = ({ children, ...props }) => {
  return <StyledCard {...props}>{children}</StyledCard>;
};

export default LegendCard;
